import {BaseCache} from "./base";

class UserInfoCache extends BaseCache {
  constructor() {
    super();
    this.key = 'userInfo';
  }
}

export const userInfoCache = new UserInfoCache();
